import {
  userBlue,
  userGreen,
  userOrange,
  userRed,
} from "@/common/components/icons/svg-icons";

export const userManagementTableHeaders = [
  "First Name",
  "Last Name",
  "Email",
  "Phone Number",
  "Role",
  "Status",
];

export const userManagementTableKeys = [
  "firstName",
  "lastName",
  "email",
  "phone",
  "role",
  "status",
];

export const getUserManagementTableData = (users: any) => {
  return users.map((user: any) => ({
    id: user.id,
    firstName: { value: user.first_name, type: "string" },
    lastName: { value: user.last_name, type: "string" },
    email: { value: user.email, type: "string" },
    phone: { value: user.phone_number, type: "string" },
    role: { value: user.roles[0].title, type: "string" },
    status: { value: user.status, type: "string" },
  }));
};

export const roleManagementTableHeaders = ["Role", "Description"];

export const roleManagementTableKeys = ["role", "description"];

export const getRoleManagementTableData = (roles: any) => {
  return roles.map((role: any) => ({
    id: role.id,
    role: { value: role.title, type: "string" },
    description: { value: role.description, type: "string" },
  }));
};

export const invitationForm = (roles: any) => [
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },

  {
    inputType: "selectInput",
    name: "role_id",
    prompt: "User type",
    options: roles,
    required: true,
    isFullWidth: false,
    returnId: true, // Ensure the component returns the ID value
  },
];

export const userManagementCards = (usersCount: any) => [
  {
    id: 1,
    name: "Total Users",
    value: usersCount?.total_users || 0,
    icon: userBlue,
    color: "#4CAF50",
  },
  {
    id: 2,
    name: "Active Users",
    value: usersCount?.active_users || 0,
    icon: userGreen,
    color: "#2196F3",
  },
  {
    id: 3,
    name: "Pending Invitations",
    value: usersCount?.pending_invitations || 0,
    icon: userOrange,
    color: "#FF9800",
  },
  {
    id: 4,
    name: "Deactivated Users",
    value: usersCount?.deactivated_users || 0,
    icon: userRed,
    color: "#F44336",
  },
];
